<template>
    <b-modal :id="id" size="sm" v-model="isShow">
        <p>{{ text }}</p>
        <template #modal-footer="{ ok, hide }">
            <b-button class="btn btn_md btn_gray" @click="hide,fn_close('hide')" v-show="oneBtn">{{ btnLeft }}</b-button>
            <b-button :class="`btn btn_md ${className}`" @click="ok,fn_close('ok')">{{ btnRight }}</b-button>
        </template>
    </b-modal>

</template>

<script>
    export default {
        props: {
            id: String,
            text: String,
            btnLeft: String,
            btnRight: String,
            oneBtn: Boolean,
            isShow: Boolean,
            className: {
                type: String,
                default: 'btn_blue'
            }
        },
        methods: {
            fn_close(type){
                
               if(type == "ok" && this.oneBtn == false){
                    this.$emit('callback',"close"); 
               }else{
                    this.$emit('callback',type); 
               }                
            }
        }
    }
</script>

<style>

</style>